import React, { useEffect, useState } from 'react'
import PurchaseOrderDashboard from './PurchaseOrderDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPurchaseOrdersDashboardFilters } from '../../../containers/actions/common/purchaseOrderAction';
import usePrevious from '../../helpers/previousProps';

const PurchaseOrderTabs = () => {
  const dispatch = useDispatch();
  const [savedFilter, setSavedFilter] = useState({});

  const purchaseOrderFilter = useSelector((state) =>
      state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters?.status
        ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters
        : {}
  );
  
  useEffect(() => {
    dispatch(fetchPurchaseOrdersDashboardFilters());
  }, [dispatch])

  let previousPurchaseOrderFilter = usePrevious(purchaseOrderFilter)

  
  useEffect(() => {
      if (
        JSON.stringify(purchaseOrderFilter) !==
        JSON.stringify(previousPurchaseOrderFilter)
      ) {
        const savedFilterData = purchaseOrderFilter?.save_filter_options && typeof purchaseOrderFilter?.save_filter_options === "object" ? purchaseOrderFilter?.save_filter_options : {};
        setSavedFilter(savedFilterData);            
          
      }
  }, [previousPurchaseOrderFilter, purchaseOrderFilter]);
  

  return <PurchaseOrderDashboard savedFilter={savedFilter} />
}

export default PurchaseOrderTabs